import dynamic from "next/dynamic";
import { useState } from "react";
import { urlDev, showPreview, getMultiIcon, showAuthor, showUppertitle } from "../../Config/Functions/Functions";
import axios from "axios";
const NewsVertical04 = dynamic(() => import('../NotaBanners/NewsVertical04'));
const NewsVertical05 = dynamic(() => import('../NotaBanners/NewsVertical05'));

const LastNews = ({ data }) => {
    const [cantidad, setCantidad] = useState(10);

    const array = []
    function random(min, max) {
        return Math.floor((Math.random() * (max - min + 1)) + min);
    }
    if (process.browser) {
        let leftColumn = document.querySelector('.left-column')

        for (let i = 0; i < cantidad; i++) {
            array.push(data[i])
        }
        function aumentar(cantidad) {
            const comscore = axios.get(self.COMSCORE && COMSCORE.beacon({c1: "2", c2: "32278281"}));
            const comscore2 = axios.get(`/comscore_view.txt?${random(1,100000)}`);
            if (cantidad < 20) {
                setCantidad(cantidad + 10)
                leftColumn.classList.add('finished')
            } else {
                setCantidad(20)
            }
        }
    }
    return (
        <>
            {data ?
                <section className="ultimas-noticias">
                    <div className="left-column has-mobile-gutter">
                        <header>
                            <h3 className="vertical-section-title">Últimas noticias</h3>
                        </header>
                        {
                            array.map((dat, index) =>
                                <article className="medium-entry-box" key={index}>
                                    <picture>
                                        {
                                            dat.preview ?
                                                <>
                                                    <img src={urlDev + dat.preview.sizes[0]?.url} width={320} height={180} alt={dat.main?.title?.home} title={dat.main?.title?.home} loading="lazy" />
                                                </>
                                                :
                                                <>
                                                    {showPreview(dat.main?.title?.home, "320", "180")}
                                                </>
                                        }
                                        {/*getMultiIcon(dat.hascontent.hasgalleryvideosyoutube, dat.gallery.length > 1, dat.hascontent.hasaudios)*/}
                                    </picture>
                                    <div className="entry-data">
                                        <h3 className="entry-title">{showUppertitle(dat.main?.uppertitle)}{dat.main?.title?.home}</h3>
                                        {dat.main?.authors ? showAuthor(dat.main?.authors[0]?.fullname) : null}
                                    </div>
                                    <a href={dat.info?.link?.url} className="cover-link" title={dat.main?.title?.home}></a>
                                </article>
                            )
                        }
                        {
                            cantidad < 20 ?
                                <button className="more-news-btn flex-container align-center justify-center" onClick={() => aumentar(cantidad)} aria-label="Ver más noticias" title="Ver más noticias">
                                    <span>Ver más noticias</span>
                                    <svg width="8.121" height="10.254" viewBox="0 0 8.121 10.254">
                                        <path d="M0,4.872H7.529L4.681,8.121H6.694l3.56-4.06L6.694,0H4.681L7.529,3.248H0Z" transform="translate(8.121) rotate(90)" fill="#fb0d01" />
                                    </svg>
                                </button>
                                : null
                        }
                    </div>
                    <div className="right-column has-mobile-gutter">
                        <NewsVertical04 />
                        <NewsVertical05 />
                    </div>
                </section>
                : null}
        </>
    )
}

export default LastNews;